import { purchaseOrderIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";
import { PurchaseOrderDetailsSchema } from "./get-purchase-order";

export const getPurchaseOrdersByIds = {
  name: "getPurchaseOrdersByIds" as const,
  input: z.object({ purchaseOrderIds: z.array(purchaseOrderIdFormat.schema) }),
  output: z.object({ purchaseOrders: z.array(PurchaseOrderDetailsSchema) }),
};
